import React from "react";
import "@/App.css";
import { Shell } from "@/jigyasa/Shell";
import { StateProvider } from "@/jigyasa/state";
import { INSTALL_PARAMS } from "@/jigyasa/config";
import StandaloneApp from "@/standalone/StandaloneApp";
import GodPanel from "@/god/GodPanel";
import { UpdateToast } from "@/standalone/InstallApp";

const isDemo = () => {
  if (typeof window === "undefined") return false;
  const params = new URLSearchParams(window.location.search);
  return params.get("demo") === "1";
};

// Demo stand-in for the host's onConverted callback (contract §2.3):
// returns a deterministic fake deal value, like Kreta's pricing logic would.
const demoOnConverted = (enquiryId) => {
  const seed = String(enquiryId).split("").reduce((s, c) => s + c.charCodeAt(0), 0);
  return { host_account_id: "demo-account", deal_value: 20000 + (seed % 60) * 1000 };
};

function App() {
  let content;
  if (typeof window !== "undefined") {
    // Forgiving address: //god, /god/ and /GOD all land on the God Panel.
    const path = window.location.pathname.replace(/\/+/g, "/").replace(/\/+$/, "").toLowerCase();
    if (path === "/god") content = <GodPanel />;
  }
  if (!content && isDemo()) {
    content = (
      <StateProvider demoMode onConverted={demoOnConverted} lookupTrigger={INSTALL_PARAMS.lookupTrigger}>
        <Shell />
      </StateProvider>
    );
  }
  if (!content) content = <StandaloneApp />;
  return (
    <>
      {content}
      <UpdateToast />
    </>
  );
}

export default App;
